import * as Sentry from '@sentry/react';

import { GlobalErrorCode } from './global-error-handler.types';

export const globalErrorHandler: Record<GlobalErrorCode, () => void> = {
  INVALID_ACCESS_TOKEN_ERROR: () => Sentry.captureMessage(`$INVALID_ACCESS_TOKEN_ERROR occurred`),
  THROTTLING_ERROR: () => undefined,
  UPDATE_REQUIRED_ERROR: () => undefined,
};
